import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { DsyTagConf } from '../../models/dsy-tabs.model';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { RoutesName } from '../../shared/constants/routes-name';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { TabsStore } from '../../services/stores/tabs.store';

@Component({
  selector: 'dr-ops-stream-ui-home',
  imports: [RouterOutlet],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  readonly tabsStore = inject(TabsStore);
  private readonly router = inject(Router);
  // Define tabs configuration first, so it's available in ngOnInit
  readonly tabs: DsyTagConf[] = [
    {
      id: RoutesName.WORLD_CLOCK,
      label: 'World Clock',
      shouldRenderSlot: false,
      onTabClickCallback: () => {
        this.router.navigate([RoutesName.WORLD_CLOCK]);
      },
    },
    {
      id: RoutesName.SHIFT_LOG,
      label: 'Shift Log',
      shouldRenderSlot: false,
      onTabClickCallback: () => {
        this.router.navigate([RoutesName.SHIFT_LOG]);
      },
    },
    {
      id: RoutesName.HANDOVER_LOG,
      label: 'Handover Log',
      shouldRenderSlot: false,
      onTabClickCallback: () => {
        this.router.navigate([RoutesName.HANDOVER_LOG]);
      },
    },
    {
      id: RoutesName.HIGH_ALERTS,
      label: 'High Alerts',
      shouldRenderSlot: false,
      onTabClickCallback: () => {
        this.router.navigate([RoutesName.HIGH_ALERTS]);
      },
    },
  ];

  constructor() {
    // Listen to route changes to keep tabs in sync
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((event: NavigationEnd) => {
        // When navigation happens, re-sync the tab state with the new URL
        this.syncTabWithUrl(event.urlAfterRedirects);
      });
  }

  ngOnInit(): void {
    // On initial load or component re-creation, sync the tab with the current URL
    this.syncTabWithUrl(this.router.url);
  }

  /**
   * Sets the active tab based on the current URL.
   * This makes the component's state reactive to the route.
   */
  private syncTabWithUrl(url: string): void {
    const activeTabIndex = this.tabs.findIndex((tab) => url.includes(tab.id as string));

    // If a matching tab is found, update the store.
    // The check for -1 prevents errors if the URL doesn't match any tab.
    if (activeTabIndex !== -1) {
      this.tabsStore.setTab(activeTabIndex);
    }
  }
}
